import './Icon_Checkcirclehp.css';

function Icon_Checkcirclehp() {
  return (
    
      <div className='checkcirclehp-icon-container'>
          <svg viewBox="0 0 24 24" className="checkcirclehp-icon-svg">
              <path d="M21.801 10A10 10 0 1 1 17 3.335"/><path d="m9 11 3 3L22 4"/>
          </svg>
      </div>
            
  );
}

export default Icon_Checkcirclehp;

//<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big-icon lucide-circle-check-big"><path d="M21.801 10A10 10 0 1 1 17 3.335"/><path d="m9 11 3 3L22 4"/></svg>